try {
  const s = document.createElement("script");
  s.src = "https://londongrocery.net/cdn/shop/t/28/assets/whatsapp-plugin.js?v=19136050626487179471680954466";
  s.type = "text/javascript";
  s.async = true;
  s.id = "df-script";

  let aisensyWidgetOptions = {
    "phoneNumber": "447385099941",
    "variant": "WhatsAppBtnAndChatWidget",
    "btnBackground": "#4dc247",
    "btnCTA": "Chat with us",
    "mb": "30",
    "ml": "30",
    "mr": "30",
    "borderRadius": "24",
    "prefilledMsg": "Hi!",
    "position": "Bottom-Right",
    "brandName": "London Grocery",
    "brandSub": "online",
    "brandColor": "#87b650",
    "brandImgUrl": "https://cdn.shopify.com/s/files/1/0358/7879/7448/files/london-grocery.png?v=1680954345",
    "widgetBtnCTA": "Start chat",
    "openWidgetByDefault": "true",
    "openWidgetSessionWindow": "24_HOUR",
    "onscreenMsg": "Hi,\nHow can I help you ?",
    "onscreenImg": "",
    "widgetOnMobile": "true",
    "personalizedUrls": []
  };

  s.onload = function () {
    if (aisensyWidgetOptions != null) {
      window.CreateWhatsAppButtonAndWidget(aisensyWidgetOptions);
    }

    // Register event listener for url change
    history.pushState = ((f) =>
      function pushState() {
        var ret = f.apply(this, arguments);
        window.dispatchEvent(new Event("pushstate"));
        window.dispatchEvent(new Event("locationchange"));
        return ret;
      })(history.pushState);

    history.replaceState = ((f) =>
      function replaceState() {
        var ret = f.apply(this, arguments);
        window.dispatchEvent(new Event("replacestate"));
        window.dispatchEvent(new Event("locationchange"));
        return ret;
      })(history.replaceState);

    window.addEventListener("popstate", () => {
      window.dispatchEvent(new Event("locationchange"));
    });

    // Listen for url change
    window.addEventListener("locationchange", () => {
      if (aisensyWidgetOptions != null) {
        window.CreateWhatsAppButtonAndWidget({ ...aisensyWidgetOptions });
      }
    });
  };
  document.body.appendChild(s);
} catch (err) {
  console.log(err);
}
